import { IRecipe } from 'types';
import { COLLECTIONS } from 'constants/collections';
import {
  getDocument,
  getDocuments,
  updateDocument,
  createDocument,
  deleteDocument,
} from 'utils/firebase';

export const list = () => {
  return getDocuments({ collection: COLLECTIONS.RECIPES });
};

export const get = (id: string) => {
  return getDocument({ collection: COLLECTIONS.RECIPES, id: id });
};

export const update = (id: string, data: Partial<IRecipe>) => {
  return updateDocument({ collection: COLLECTIONS.RECIPES, id, data });
};

export const create = (data: Partial<IRecipe>) => {
  return createDocument({ collection: COLLECTIONS.RECIPES, data });
};

export const remove = (id?: string) => {
  return deleteDocument({ collection: COLLECTIONS.RECIPES, id });
};
